<abp-page [title]="'Saas::Tenants' | abpLocalization" [toolbar]="data.items">
  <div id="wrapper">
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <!-- Barra de busca -->
          <form #filterForm (keyup.enter)="list.get()">
            <div class="input-group">
              <span class="input-group-text" role="button" (click)="list.get()">
                <i class="fas fa-search"></i>
              </span>
              <input
                name="filterText"
                type="text"
                class="form-control"
                placeholder="Buscar..."
                [(ngModel)]="this.filterText"
              />
            </div>
          </form>
          <button
            type="button"
            class="btn btn-outline-primary ms-2 h-100"
            (click)="toggleFilters()"
          >
            {{ showFilters ? 'Esconder Filtros' : 'Mostrar Filtros' }}
          </button>
          <!-- Botão para mostrar/ocultar o formulário -->
        </div>
      </div>


      <div *ngIf="showFilters" class="mt-3 ps-3 pe-sm-0 pe-3">
        <abp-advanced-entity-filters-form>

        <form #filterForm [formGroup]="formFilters">


        <div class="row">
          <div class="col-12 col-sm-3">
            <div class="mb-3">
              <label for="activationState" class="form-label">{{
                'Saas::DisplayName:ActivationState' | abpLocalization
              }}</label>
              <select
                id="activationState"
                class="form-select form-control"
                formControlName="activationState"
              >
                <option [ngValue]="null">-</option>
                @for (data of activationStateOptions; track $index) {
                  <option [ngValue]="data.key">
                    {{ 'Saas::Enum:TenantActivationState.' + data.key | abpLocalization }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-auto align-self-end mb-3">
            <div class="row">
              <div class="col-6 col-sm-auto d-grid">
                <button type="button" class="btn btn-outline-primary" (click)="clearFilters()">
                  <span>{{ 'AbpUi::Clear' | abpLocalization }}</span>
                </button>
              </div>
              <div class="col-6 col-sm-auto d-grid">
                <button
                  type="button"
                  class="btn btn-primary"
                  [disabled]="formFilters.invalid"
                  (click)="getData()"
                >
                  <span>{{ 'AbpUi::Refresh' | abpLocalization }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
        </abp-advanced-entity-filters-form>
      </div>

      <div class='card-body'>
        <abp-extensible-table
          [data]="data.items"
          [recordsTotal]="data.totalCount"
          [list]="list"
        ></abp-extensible-table>
      </div>

    </div>
  </div>
</abp-page>

<abp-modal [(visible)]="isModalVisible" [busy]="modalBusy" [options]="{ size: 'lg' }">
  <ng-template #abpHeader>
    <h3>{{ selectedModalContent.title | abpLocalization }}</h3>
  </ng-template>

  <ng-template #abpBody>
    <ng-container *ngTemplateOutlet="selectedModalContent?.template"></ng-container>
  </ng-template>

  <ng-template #abpFooter>
    <button abpClose type="button" class="btn btn-outline-primary">
      {{ 'Saas::Cancel' | abpLocalization }}
    </button>
    @switch (selectedModalContent?.type) {
      @case ('saveTenant') {
        <abp-button iconClass="fa fa-check" buttonType="submit" formName="editOrCreateForm"
          >{{ 'AbpUi::Save' | abpLocalization }}
        </abp-button>
      }
      @case ('saveConnStr') {
        <abp-button
          iconClass="fa fa-check"
          [disabled]="isDisabledSaveButton"
          (click)="save()"
          >{{ 'AbpUi::Save' | abpLocalization }}
        </abp-button>
      }
    }
  </ng-template>
</abp-modal>

@if (setTenantReplaceableTemplateOptions) {
  <abp-set-tenant-password-modal
    *abpReplaceableTemplate="setTenantReplaceableTemplateOptions"
    [modalVisible]="isVisibleSetTenantPasswordModal"
    [tenantId]="selectedTenantId"
    [tenantName]="selectedTenantNameForSetTenantPasswordModal"
    (modalVisibleChange)="closeSetTenantPasswordModal()"
  >
  </abp-set-tenant-password-modal>
}

<ng-template #tenantModalTemplate>
  <ng-container *ngTemplateOutlet="selected?.id ? tenantFormTmp : createTenantTmp"></ng-container>

  <ng-template #createTenantTmp>
    <ul ngbNav #nav="ngbNav" [destroyOnHide]="false" class="nav-tabs">
      <li ngbNavItem>
        <a ngbNavLink>{{ 'Saas::TenantBaseInfo' | abpLocalization }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="tenantFormTmp"></ng-container>
        </ng-template>
      </li>
      <li style="display: none;" ngbNavItem>
        <a ngbNavLink>{{ 'Saas::ConnectionStrings' | abpLocalization }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="connectionStrings"></ng-container>
        </ng-template>
      </li>
    </ul>

    <div [ngbNavOutlet]="nav"></div>
  </ng-template>

  <ng-template #tenantFormTmp>
    @if (tenantForm) {
      <form
        class="py-2"
        id="editOrCreateForm"
        [formGroup]="tenantForm"
        (ngSubmit)="save()"
        validateOnSubmit
      >
        <abp-extensible-form [selectedRecord]="selected"></abp-extensible-form>
      </form>
    }
  </ng-template>

  <ng-template #connectionStrings>
    <abp-connection-strings
      *abpReplaceableTemplate="{
        outputs: { formSubmit: save },
        componentKey: connectionStringsReplacementKey
      }"
      (formSubmit)="save()"
    ></abp-connection-strings>
  </ng-template>
</ng-template>

<ng-template #connectionStringModalTemplate>
  <abp-connection-strings
    *abpReplaceableTemplate="{
      inputs: {
        selectedTenant: { value: selected }
      },
      outputs: { formSubmit: save },
      componentKey: connectionStringsReplacementKey
    }"
    [selectedTenant]="selected"
    (formSubmit)="save()"
  ></abp-connection-strings>
</ng-template>

@if (providerKey) {
  <abp-feature-management
    *abpReplaceableTemplate="{
      inputs: {
        providerName: { value: 'T' },
        providerKey: { value: providerKey },
        visible: { value: visibleFeatures, twoWay: true }
      },
      outputs: { visibleChange: onVisibleFeaturesChange },
      componentKey: 'FeatureManagement.FeatureManagementComponent'
    }"
    [(visible)]="visibleFeatures"
    providerName="T"
    [providerKey]="providerKey"
  >
  </abp-feature-management>
}

<abp-impersonate-tenant-modal />
